import { HelpText, Label, Tooltip, UtilityButton } from '@lego/connect-components-react';
import type { FormFieldState, FormVariableState } from '@/types/types';

// Fixed label row height so all columns align regardless of help icon presence
export const labelRowClass = 'flex items-center gap-75 h-[24px] mb-75';

// Shared native input styling (for types Connect TextField doesn't support)
const nativeInputClass = `w-full h-[40px] max-h-[40px] rounded-100 border border-core-slate-300 bg-core-white px-200 text-body-sm text-core-slate-1300 outline-none focus:border-core-blue-700 transition-colors`;

export const NativeInput = ({
  type = 'text',
  value,
  onChange,
  min,
  className,
}: {
  type?: string;
  value: string;
  onChange: (value: string) => void;
  min?: number;
  className?: string;
}) => (
  <input
    type={type}
    min={min}
    className={`${nativeInputClass} ${className ?? ''}`}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);

export const LabeledField = ({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: React.ReactNode;
}) => (
  <div>
    <Label size="small">{label}</Label>
    {children}
    {hint && <HelpText size="small">{hint}</HelpText>}
  </div>
);

export const FieldGroup = ({
  label,
  tooltip,
  children,
}: {
  label: string;
  tooltip?: string;
  children: React.ReactNode;
}) => (
  <div>
    <div className={labelRowClass}>
      <Label size="small">{label}</Label>
      {tooltip && <InfoTip text={tooltip} />}
    </div>
    {children}
  </div>
);

export const inferVariableType = (field?: FormFieldState | null): FormVariableState['type'] => {
  if (!field) return '';
  return field.type === 'Double' ? 'Integer' : 'String';
};

export const getVariableTypeOptions = (field?: FormFieldState | null) => {
  if (!field) return [];
  return field.type === 'Double' ? ['String', 'Integer'] : ['String'];
};

export const InfoTip = ({ text }: { text: string }) => (
  <Tooltip position="top">
    <Tooltip.Trigger>
      <UtilityButton iconName="circle-question" size="small" appearance="ghost" aria-label={text} />
    </Tooltip.Trigger>
    <Tooltip.Content>{text}</Tooltip.Content>
  </Tooltip>
);
